export default "https://cdn-static.gokick.com/assets/1efca0ef19d403b8805a53d90e225e0b5d561c25/images/picture-of-you.b930d7b92f771d9006a5673f9ae1716c.svg";